import { initStore } from '../../../common';
import { actions } from './actions';

export const profileSettingsStore = (): void => {
	const initialState = {
		slice: 'PROFILE',
		userId: '',
		username: '',
		usernameInvalid: false,
		email: '',
		emailInvalid: false,
		partners: [],
		activePartners: [],
		permissions: {},
		isActive: true,
		lastActivity: '',
		image: null,
		errors: [],
		success: '',
	};

	initStore(actions, initialState);
};
